//      
import React from 'react';

import FormattedDate, {                         } from './FormattedDate';

/** Basically the same as FormattedDate but with different defaults */
export const FormattedDateTime = (props                    ) => (
    <FormattedDate {...props} className='datetime-component' />
);

FormattedDateTime.defaultProps = {
    format: 'lll',
    helpFormat: 'LLLL',
};

export default FormattedDateTime;
